module.exports = __webpack_public_path__ + "static/img/Actitive.104e4087.png";